import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import { DSIcon } from '../../../base';
import Tooltip from '../Tooltip/Tooltip';

import styles from './Scoring.module.scss';

const Scoring = ({
  score,
  totalReviews,
  className = '',
  size = 'small',
  bold = true,
  tooltipPosition = 'left'
}) => {
  const classes = classNames(
    styles.scoring__content,
    styles[`scoring__content--${size}`],
    {
      [styles['scoring__content--bold']]: bold
    },
    className
  );
  return (
    <Tooltip
      color="tertiary"
      tooltip={trans('scoring-tooltip')}
      textClassName={styles.scoring__tooltip}
      trigger={['click', 'hover']}
      position={tooltipPosition}
    >
      <div className={classes}>
        <DSIcon name="star" />
        <span>
          {score / 100} ({totalReviews})
        </span>
      </div>
    </Tooltip>
  );
};

Scoring.propTypes = {
  score: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  bold: PropTypes.bool,
  tooltipPosition: PropTypes.oneOf(['left', 'right', 'top', 'bottom'])
};

export default Scoring;
